import React, { useState } from "react";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { ContextTypes } from "api/model/dashboard/DashboardTab";
import { Button } from "primereact/button";
import useDashboardStore from "store/dashboard-store";
import { adjustReferenceTime } from "../../utils";

interface TabContextMenuProps {
  tabId: number;
}

const TabContextMenu = ({ tabId }: TabContextMenuProps) => {
  const setTabContextConfig = useDashboardStore(state => state.setTabContextConfig);
  const getTabContextConfig = useDashboardStore(state => state.getTabContextConfig);
  const triggerTabRefresh = useDashboardStore(state => state.triggerTabRefresh);

  const tabContextConfig = getTabContextConfig(tabId) || {};
  const [currentTabContextConfig, setCurrentTabContextConfig] = useState<any>(tabContextConfig);

  const referenceTime = adjustReferenceTime(tabContextConfig.config).referenceTime || Date.now();

  const handleInputChange = (idTab: number, newConfig: any) => {
    setTabContextConfig(idTab, newConfig);
    setCurrentTabContextConfig(newConfig);
  };
  const from = adjustReferenceTime(tabContextConfig.config).dateFrom || Date.now();

  const to = adjustReferenceTime(tabContextConfig.config).dateTo || Date.now();

  return (
    <div className="flex flex-row gap-2">
      {tabContextConfig?.contextType === ContextTypes.RANGE_DATE_SELECTION ? (
        <div className="flex flex-row gap-2 my-3">
          <div>
            <label htmlFor="Date From">Date From</label>
            <div className="flex flex-row">
              <CalendarWrapper
                id="dateFrom"
                value={tabContextConfig.from ? new Date(tabContextConfig.from) : new Date(from)}
                onChange={e =>
                  handleInputChange(tabId, { ...currentTabContextConfig, from: e.toISOString() })
                }
                className="w-3 align-self-center"
                debounceTimeInMs={300}
              />
            </div>
          </div>
          <div>
            <label htmlFor="Date To">Date To</label>
            <div className="flex flex-row">
              <CalendarWrapper
                id="dateTo"
                value={tabContextConfig.to ? new Date(tabContextConfig.to) : new Date(to)}
                onChange={e =>
                  handleInputChange(tabId, { ...currentTabContextConfig, to: e.toISOString() })
                }
                className="w-3 align-self-center"
                debounceTimeInMs={300}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-column gap-2 my-3">
          <label htmlFor="referenceTime">Reference Time</label>
          <div className="flex flex-row">
            <CalendarWrapper
              id="referenceTime"
              value={
                tabContextConfig.referenceTime
                  ? new Date(tabContextConfig.referenceTime)
                  : new Date(referenceTime)
              }
              onChange={e =>
                handleInputChange(tabId, {
                  ...currentTabContextConfig,
                  referenceTime: e.toISOString(),
                })
              }
              className="w-3 align-self-center"
              debounceTimeInMs={300}
            />
          </div>
        </div>
      )}
      <Button
        icon="pi pi-play"
        tooltip="Fetch Data"
        onClick={() => triggerTabRefresh()}
        className="p-button-success h-3rem align-self-center mt-3"
      />
    </div>
  );
};

export default TabContextMenu;
